
import FAQ from "@/components/cayman/FAQ";

interface FAQSectionProps {
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}

const FAQSection = ({ faqs }: FAQSectionProps) => {
  return (
    <section className="py-20 px-4">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-3xl font-bold mb-12 text-center">
          Frequently Asked Questions
        </h2>
        
        <FAQ faqs={faqs} />
      </div>
    </section>
  );
};

export default FAQSection;
